import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { systemColors } from '@eti/debug';

// Generates a string for the striped background
// repeating-linear-gradient(45deg, #0089c1, #0089c1 20px, #c50030 20px, #c50030 40px)
const getProviderSystemBackground = (providerSystems = {}) =>
  `repeating-linear-gradient(${providerSystems.reduce((stripeColorString, system, i) => {
    const systemColor = systemColors[system];
    const width = 100 / providerSystems.length;
    return `${stripeColorString},${systemColor} ${i * width}%,${systemColor} ${(i + 1) * width}%`;
  }, '45deg')})`;

const providerSystemHeaderStyles = (providerSystems) => css`
  background: ${getProviderSystemBackground(providerSystems)};
  color: ${etiColors.white};
  display: flex;
  font-weight: 700;
  height: 20px;
`;

const providerTitleWrapperStyles = (width) => css`
  align-items: center;
  display: flex;
  flex-basis: ${width};
  justify-content: center;
  overflow-x: hidden;
`;

const providerTitleStyles = css`
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

const DebugProviderSystemBar = ({ providerSystems }) => {
  const providerSystemsWithIds = providerSystems.map((name, index) => ({ name, id: index }));

  return (
    <div className={providerSystemHeaderStyles(providerSystems)}>
      {providerSystemsWithIds.map((providerSystem) => (
        <div
          className={providerTitleWrapperStyles(`${100 / providerSystems.length}%`)}
          key={providerSystem.id}
        >
          <span className={providerTitleStyles}>{providerSystem.name}</span>
        </div>
      ))}
    </div>
  );
};

DebugProviderSystemBar.propTypes = {
  providerSystems: PropTypes.arrayOf(PropTypes.string),
};

export default DebugProviderSystemBar;
